export class SaveResult {
    private _id: any;
    private _trackingId: any;
    private _city: string;
    private _pickupAddressLine1: string;
    private _stringId: any;
    private _errors: Array<string>;
    private _rowVersion: any;
    private _pickupCountry: string;
    private _destinationCountry: string;
    private _transportationMode: string;
    private _packageType: string;
    private _totalShippingCost: number;
    private _isPackageSizeGreater: boolean;
    private _orderNumber: number;
    private _deliveryNumber: number;
    private _sapErrorMessage: string;


    get city(): any {
        return this._city;
    }

    get pickupAddressLine1(): any {
        return this._pickupAddressLine1;
    }

    get trackingId(): any {
        return this._trackingId;
    }

    get rowVersion(): any {
        return this._rowVersion;
    }

    get pickupCountry(): any {
        return this._pickupCountry;
    }

    get destinationCountry(): any {
        return this._destinationCountry;
    }

    get transportationMode(): any {
        return this._transportationMode;
    }

    get packageType(): any {
        return this._packageType;
    }

    get totalShippingCost(): any {
        return this._totalShippingCost;
    }

    get isPackageSizeGreater(): any {
        return this._isPackageSizeGreater;
    }
    
    get errors(): Array<string> {
        return this._errors;
    }

    get orderNumber(): any {
        return this._orderNumber;
    }

    get deliveryNumber(): any {
        return this._deliveryNumber;
    }

    get sapErrorMessage(): any {
        return this._sapErrorMessage;
    }
    constructor(errors: Array<string>, trackingId: number = 0, rowVersion: any, pickupAddressLine1: string, city: string, pickupCountry: string, destinationCountry: string,
        transportationMode: string, packageType: string, totalShippingCost: number, isPackageSizeGreater: boolean) {
        this._trackingId = trackingId;
        this._city = city;
        this._pickupAddressLine1 = pickupAddressLine1;
        this._pickupCountry = pickupCountry;

        this._pickupCountry = pickupCountry;
        this._destinationCountry = destinationCountry;
        this._transportationMode = transportationMode;
        this._packageType = packageType;
        this._totalShippingCost = totalShippingCost;
        this._isPackageSizeGreater = isPackageSizeGreater;
        this._errors = errors;
        this._rowVersion = rowVersion;
    }
    
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/saveResult.ts
 **/